<template>
  <div style="height: 100%">
    <div class="publication-pc-body">
      <div class="publication-body">
        <div class="title">{{publication.title}}</div>
        <div class="content">
          <div class="left">
            <div class="publication-title">{{publication.title}}</div>
            <div v-for="(item) in publication.list" :key="item.group" @click="clickGroup(item.group)">
              <div :class="selectedGroup != item.group ? 'publication-detail-group' : 'publication-detail-group-selected'">{{item.group}}</div>
            </div>
          </div>
          <div class="right">
            <div class="right-title">{{selectedGroup}}</div>
            <div v-for="(item) in selectedList" :key="item.group" class="publication-detail">
                <div class="paper-list-title">
                  <span style="font-weight:700;">{{item.id}}. </span>{{item.title}}
                </div>
                <div class="paper-list-member" v-if="item.members">{{item.members}}</div>
                <div class="paper-list-info">
                  <span style="font-weight:700;">{{item.paper}} </span>{{item.others}} <a :href="'static/' + item.pdfPath" target="_blank">{{getMoreText}} ▶</a>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="publication-mobile-body">
      <div class="header" @click="showMobileMenu()">{{selectedGroup}} <i class="el-icon-arrow-down" v-show="!isMobileMenuShow" /><i class="el-icon-arrow-up" v-show="isMobileMenuShow" /></div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div v-for="(item) in publication.list" :key="item.group" @click="clickGroup(item.group)" class="header-menu-item">
          <div :class="selectedGroup != item.group ? 'publication-detail-group' : 'publication-detail-group-selected'">{{item.group}}</div>
        </div>
      </div>
      <div class="publication-body">
        <div class="title">{{publication.title}}</div>
        <div class="content">
          <div v-for="(item) in selectedList" :key="item.group" class="publication-detail">
              <div class="paper-list-title">
                <span style="font-weight:700;">{{item.id}}. </span>{{item.title}}
              </div>
              <div class="paper-list-member" v-if="item.members">{{item.members}}</div>
              <div class="paper-list-info">
                <span style="font-weight:700;">{{item.paper}} </span>{{item.others}} <a :href="'static/' + item.pdfPath" target="_blank">{{getMoreText}} ▶</a>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan, isChinese} from '@/util/tools'
export default {
  name: 'publication-page',
  data () {
    return {
      selectedGroup: '',
      selectedList: [],
      isMobileMenuShow: false,
      publication:
      {
          title: "发表论文",
          list: [
          {
              group: "2020",
              datalist: [
              {
                  title: "137. Topological electronic structure in the antiferromagnet HoSbTe",
                  members: "Shaosheng Yue, Yuting Qian, Meng Yang, Daiyu Geng, Changjiang Yi, Shiv Kumar, Kenya Shimada, Peng Cheng, Lan Chen, Zhijun Wang, Hongming Weng, Youguo Shi, Kehui Wu, Baojie Feng",
                  paper: "Phys. Rev.",
                  others: " B 102, 155109(2020)"
              }]
          }]
      }  
    }
  },
  computed: {
    getMoreText: function () {
      if (isChinese()) {
        return '查看论文'
      } else {
        return 'More'
      }
    }
  },
  mounted () {
    var self = this
    getCurLan().then(res => {
      self.publication = res.publication
      if (self.publication.list.length > 0) {
        self.clickGroup(self.publication.list[0].group)
      }
    })
    // this.publication = getCurLan().publication;
    // if (this.publication.list.length > 0) {
    //   this.clickGroup(this.publication.list[0].group)
    // }
  },
  methods: {
    clickGroup (group) {
      this.selectedGroup = group
      var data = this.publication.list.filter(item => {
        return item.group === group
      })[0]
      this.selectedList = data.datalist
      if(this.isMobileMenuShow) {
        this.showMobileMenu()
      }
    },
    showMobileMenu () {
      this.isMobileMenuShow = !this.isMobileMenuShow
    }
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/publication-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/publication-page.scss'></style>


// WEBPACK FOOTER //
// src/components/Publication.vue